var _path, _g, _path2, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.724H8.828A8.829 8.829 0 0 1 0 414.896V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.792a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#73af00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.086 88.276L0 334.021v26.385l415.355-272.13zM512 177.979v-26.385L96.644 423.724h40.269z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 151.594v-54.49a8.829 8.829 0 0 0-8.828-8.828h-87.817L0 360.406v54.49a8.829 8.829 0 0 0 8.828 8.828h87.817L512 151.594z",
    fill: "#464655"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.018 275.9l18.119 14.59 19.67-12.42c2.547-1.608 5.675.951 4.602 3.766l-8.277 21.74 17.89 14.869c2.316 1.926.849 5.69-2.159 5.542l-23.234-1.154-8.613 21.61c-1.116 2.797-5.15 2.567-5.938-.341l-6.082-22.454-23.213-1.514c-3.006-.196-4.032-4.105-1.511-5.752l19.475-12.724-5.734-22.546c-.74-2.918 2.66-5.102 5.005-3.212zM323.007 166.29l18.119 14.59 19.67-12.42c2.547-1.608 5.675.951 4.602 3.766l-8.277 21.74 17.89 14.869c2.316 1.926.849 5.69-2.159 5.542l-23.234-1.154-8.613 21.61c-1.116 2.797-5.15 2.566-5.938-.341l-6.082-22.454-23.213-1.514c-3.006-.196-4.032-4.105-1.511-5.752l19.475-12.724-5.734-22.546c-.741-2.916 2.659-5.101 5.005-3.212z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 414.896V177.979L136.913 423.724h366.258a8.828 8.828 0 0 0 8.829-8.828z",
    fill: "#ff4b55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKn);
export default __webpack_public_path__ + "static/media/kn.5f8b21a858b1205217768a80b0e07196.svg";
export { ForwardRef as ReactComponent };